function HomeController(){
	this.className			= "HomeController";
	this.view				= false; //"example";
	this.glob				= ["/", "/?*"];
	// this.glob				= ["/", "/?*", "/home*"];
    this.viewData			= {};
    this.log                = false;
    

}

HomeController.inheritsFrom( PageController );
HomeController.prototype.setup = function(onComplete){
	if(this.isSetup) return;

	this.$body				= $('body');

	this.baseController = Aviator.get("baseController")
    this.isMobile = this.baseController.isMobile();

	this.isSetup = true;
}
HomeController.prototype.swap = function(onComplete){
    if(!this.isSetup) this.setup();

	this.animationGroups = [];

	this.imageController = this.baseController.getImageController();
	this.configLettersAnimation();

    this.imageLoadedOrFailedDelegate =  (e) => {
        if(!e.image) return; //Early ones aren't ready with an image

        const $container = e.image.$wrapper;
        const index = $container.attr("data-index") * 1;
        this.updateLettersAnimation(index);

        //Check all the images have loaded before showing anything...
        if(e.target.images.every(i => i.loaded || i.status == "failed")){
            onComplete();
        }

    };

	this.imageController.addListener("refresh",this.imageLoadedOrFailedDelegate);
    this.imageController.addListener("failed",this.imageLoadedOrFailedDelegate);


     new AnimationController({
        containerSelector: '#our-stats',
        triggerStart: 'top 50%',
        triggerEnd: 'top top',
        showMarkers: false,
        once: true,
        onScroll: false,
        items: [{
            selector: '.js-stat-item',
            start: { opacity: 0 },
            end: { opacity: 1 },
            options: {
                duration: 0.5,
                stagger: 0.25
            }
        }],
    });

    /*
    document.querySelectorAll('#our-services .js-service-item').forEach((container, i) => {
        const index = i + 1;
        const itemSelector = `#our-services .js-service-item:nth-child(${index})`;

        let containerSelector = itemSelector;
        if(!this.isMobile) containerSelector = "#our-services";

        new AnimationController({
            containerSelector: containerSelector,
            triggerStart: this.isMobile ? 'top 90%' : 'top 50%',
            triggerEnd: 'top top',
            showMarkers: false,
            once: true,
            onScroll: false,
            items: [{
                selector: itemSelector,
                start: { opacity: 0 },
                end: { opacity: 1 },
                options: {
                    duration: 1,
                    delay: 0.25 * i,
                }
            }],
        });
    });
    */

    /*
    document.querySelectorAll('#our-clients .js-testimonial-item').forEach((container, i) => {
        const index = i + 1;
        const itemSelector = `#our-clients .js-testimonial-item:nth-child(${index})`;

        let containerSelector = itemSelector;
        if(!this.isMobile) containerSelector = "#our-clients";

        new AnimationController({
            containerSelector: containerSelector,
            triggerStart: this.isMobile ? 'top 90%' : 'top 50%',
            triggerEnd: 'top top',
            showMarkers: false,
            once: true,
            onScroll: false,
            items: [{
                selector: itemSelector,
                start: { opacity: 0 },
                end: { opacity: 1 },
                options: {
                    duration: 0.5,
                    delay: 0.25 * i,
                }
            }],
        });
    });
    */

    return false;
}
HomeController.prototype.on = function(onComplete){
    if (this.log) console.log(`%c[homeController]`, 'background:lightgreen', `on`);

    return true;    
}
HomeController.prototype.animateItems = function($container, items) {
    const timeline = gsap.timeline({paused: true});

    items.forEach(item => {
        timeline.fromTo(
            item.selector,
            item.from,
            item.to,
            this.animationLabel
        );
    });

    this.animation = ScrollTrigger.create({
        trigger: $container,
        animation: timeline,
        markers: false,
        start: "top 70%",
        end: "top top",
        scrub: .5,
        invalidateOnRefresh: true
    });
}
HomeController.prototype.configLettersAnimation = function() {

    if (this.log) console.log(`%c[homeController]`, 'background:lightgreen', `configLettersAnimation`);

    const containersSelector = '.concept-image-container';
    const lettersSelector = '.concept-letter';

    const containers = document.querySelectorAll(containersSelector);
    containers.forEach(container => {
        // const containerSelector = `#${container.id} .img-replace`;
        const containerSelector = `#${container.id}`;

        const letters = container.querySelectorAll(lettersSelector);
        const lettersArrayToAnimate = [];
        letters.forEach((letter) => {
            lettersArrayToAnimate.push({
                selector: `#${letter.id}`,                
                start: {
                    x: parseFloat(letter.dataset['startX']),
                    y: parseFloat(letter.dataset['startY'])
                },
                end: {
                    x: parseFloat(letter.dataset['endX']),
                    y: parseFloat(letter.dataset['endY'])
                },
                duration: parseFloat(letter.dataset['duration']),                
                delay: parseFloat(letter.dataset['delay']),
                ease: letter.dataset['ease'],
            });
        })

        const animationGroup = new AnimationController({
            containerSelector,
            items: lettersArrayToAnimate,
            triggerStart: container.dataset['triggerStart'],
            triggerEnd: container.dataset['triggerEnd'],
            showMarkers: container.dataset['showMarkers']
        });

        this.animationGroups.push(animationGroup);

    });

}
HomeController.prototype.updateLettersAnimation = function(imageIndex) {
    this.animationGroups[imageIndex].calculateContainerBaseDimensions();
}
HomeController.prototype.off = function(onComplete){
    this.imageController.removeListener("refresh",this.imageLoadedDelegate);
}